export default "__VITE_ASSET__81f9294b__"